import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import React, { Component } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SimpleConfigContext } from '../../../Context/Portal/SimpleConfigContext'
import Loader from '../../Shared/Loader/loader';
import ErrorMessage from '../../Shared/Error/ErrorMessage'
import { Checkbox } from '@progress/kendo-react-inputs';
import Skeleton from '../../Shared/Skeleton/Skeleton';
import { updateItem } from '../../../API/Portal/Portal';
import { withTranslation } from 'react-i18next';
import { getAttributes } from '../../../API/Attribute/Attribute';
import GenericTranslationDialog from '../../Entities/GenericTranslationDialog';

class MenuItems extends Component {
    static contextType = SimpleConfigContext;

    saveAttributeButton = React.createRef(null);
    attributeFormSubmitted = false;

    constructor(props) {
        super(props);
        DragCell.dragStart = this.dragStart.bind(this);
        DragCell.reorder = this.reorder.bind(this);
        DragCell.endDrag = this.endDrag.bind(this);
    }

    render() {
        const { loading, isMenuItemsTabLoadingData, showEditAttributeDialog, showEditLabelTranslationDialog, selectedEntity } =
            this.context;
        const { t } = this.props;
        if (isMenuItemsTabLoadingData) {
            return (
                <div>
                    <Loader />
                </div>
            );
        }

        if (loading) {
            return (
                <div>
                    <Skeleton
                        rows={[{ full: true }]} />
                </div>
            )
        }
        return (
            <div className="m-3">
                {showEditAttributeDialog && (
                    <Dialog
                        width={"35%"}
                        title={t('edit_attributes_dialog.title')}
                        onClose={this.closeEditAttributeDialog}
                    >
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (!this.isFirstAttributeSelected()) {
                                    return;
                                }
                                this.attributeFormSubmitted = true;
                                this.saveAttributes(e);
                            }}
                            onKeyDown={(e) => {
                                if (
                                    e.key === "Enter" &&
                                    !this.attributeFormSubmitted &&
                                    this.isFirstAttributeSelected() &&
                                    !(this.areSelectedAttributesSame() || this.areSelectedAttributesChanged() === false)
                                ) {
                                    this.attributeFormSubmitted = true;
                                    this.saveAttributes(e)
                                }
                            }}>
                            {this.areSelectedAttributesSame() && (
                                <ErrorMessage
                                    valid={false}
                                    error={t("edit_attributes_dialog.errors.same_attributes_selected")}
                                />
                            )}
                            <div className="mt-2 row">
                                <div className="no-clearBtn col-6">
                                    <label className="form-label" required>
                                        {t("edit_attributes_dialog.form_labels.first_property")}
                                    </label>
                                    <ComboBox
                                        className="w-100 select-overflow"
                                        textField="attributeName"
                                        onChange={this.updateFirstAttribute}
                                        value={this.context.selectedAttributes[0]}
                                        data={this.context.entityAttributes.filter(attr => attr.attributeType !== "Image" && attr.attributeType !== "Entity Lookup")}
                                    />
                                </div>
                                <div className=" clearBtn col-6">
                                    <label className="form-label">
                                        {t("edit_attributes_dialog.form_labels.second_property")}
                                    </label>
                                    <ComboBox
                                        className="w-100 select-overflow "
                                        textField="attributeName"
                                        onChange={this.updateSecondAttribute}
                                        value={this.context.selectedAttributes && this.context.selectedAttributes.length > 0 && JSON.stringify(this.context.selectedAttributes[1]) != '{}' ? this.context.selectedAttributes[1] : null}
                                        data={this.context.entityAttributes.filter(attr => attr.attributeType !== "Image" && attr.attributeType !== "Entity Lookup")}
                                    />
                                </div>

                            </div>

                            <div className='align'>
                                <DialogActionsBar layout="end">
                                    <button
                                        type="button"
                                        onClick={this.closeEditAttributeDialog}
                                        className="mx-1 btn btn-secondary"
                                    >
                                        {t("edit_attributes_dialog.buttons.cancel")}
                                    </button>

                                    <button
                                        type={'submit'}
                                        className="btn btn-primary"
                                        disabled={
                                            !this.isFirstAttributeSelected() ||
                                            this.areSelectedAttributesSame() ||
                                            this.areSelectedAttributesChanged() === false
                                        }
                                        onClick={this.saveAttributes}
                                        ref={this.saveAttributeButton}
                                    >
                                        {t("edit_attributes_dialog.buttons.save")}
                                    </button>
                                </DialogActionsBar>
                            </div>
                        </form>
                    </Dialog>
                )}
                {showEditLabelTranslationDialog && (
                    <GenericTranslationDialog
                        onClose={() => this.context.toggleEditLabelTranslationDialog()}
                        onSave={(languages) => {
                            debugger;
                            this.context.updateEntityLanguages({
                                entityId: selectedEntity.menuItemId,
                                languages
                            })
                            this.context.toggleEditLabelTranslationDialog()
                            this.context.setSelectedEntity({})
                        }}
                        languages={selectedEntity.languages}
                        project={this.props.project}
                        fields={["label", "tooltip"]}
                        type={t("edit_attributes_dialog.menu_item")}
                    />
                )}

                { }

                <Grid
                    data={this.context.entities.map((entity, index) => ({
                        ...entity,
                        index,
                    }))}
                >
                    <Column
                        title=""
                        cell={DragCell}
                        width="50"
                    />
                    <Column
                        title={t("grid.columns.object")}
                        cell={(e) => <td title={e.dataItem.name}>{e.dataItem.name}</td>}
                    />
                    <Column
                        title={t("grid.columns.label")}
                        cell={LabelCell}
                    />
                    {this.props.subscription.numOfLanguages > 1 &&
                        <Column
                            title={t("grid.columns.label_translation")}
                            cell={LabelTranslationCell}
                        />
                    }
                    <Column
                        title={t("grid.columns.show")}
                        cell={ShowCell}
                        width={45}
                    />
                    <Column
                        title=""
                        cell={props => <AttributeEditCell {...props} t={t} />}
                        width={60}
                    />
                </Grid>
            </div>
        );
    }

    closeEditAttributeDialog = () => {
        this.context.toggleEditAttributeDialog({
            recentRecordId: "",
            selectedAttributes: [],
            entityAttributes: [],
        });
    };

    updateFirstAttribute = (e) => {
        const { value } = e.target;
        this.context.updateAttribute(0, value);
    };

    updateSecondAttribute = (e) => {
        var value = e.target.value == null ? {} : e.target.value;
        this.context.updateAttribute(1, value);
    };

    clearSecondAttribute = (e) => {
        this.context.updateAttribute(1, {});
    }

    isFirstAttributeSelected = () => {// Renamed function
        return (
            this.context.selectedAttributes[0] &&
            this.context.selectedAttributes[0]._id
        );
    }

    areSelectedAttributesSame = () => {
        return (
            this.context.selectedAttributes[0] &&
            this.context.selectedAttributes[1] &&
            this.context.selectedAttributes[0]._id === this.context.selectedAttributes[1]._id
        );
    }

    areSelectedAttributesChanged = () => {
        const { selectedAttributes, defaultRecentRecordAttributes } = this.context;
        let isFirstAttributeChanged = false;
        if (
            (!selectedAttributes[0] && defaultRecentRecordAttributes[0]) ||
            (selectedAttributes[0] && !defaultRecentRecordAttributes[0]) ||
            (selectedAttributes[0] && defaultRecentRecordAttributes[0] && selectedAttributes[0]._id !== defaultRecentRecordAttributes[0]._id)
        ) {
            isFirstAttributeChanged = true;
        }
        let isSecondAttributeChanged = false;
        if (
            (!selectedAttributes[1] && defaultRecentRecordAttributes[1]) ||
            (selectedAttributes[1] && !defaultRecentRecordAttributes[1]) ||
            (selectedAttributes[1] && defaultRecentRecordAttributes[1] &&
                selectedAttributes[1]._id !== defaultRecentRecordAttributes[1]._id)
        ) {
            isSecondAttributeChanged = true;
        }
        return isFirstAttributeChanged || isSecondAttributeChanged
    }

    saveAttributes = async (e) => {
        e.preventDefault()
        try {
            this.saveAttributeButton.current.disabled = true;
            const { entities, selectedRecentRecordId } =
                this.context;
            const currentEntityIndex = entities.findIndex(
                (entity) => entity.recentRecordId === selectedRecentRecordId
            );
            const currentEntity = entities[currentEntityIndex];
            const newRecentRecordAttributes = [];
            if (this.context.selectedAttributes[0]) {
                newRecentRecordAttributes.push(this.context.selectedAttributes[0]._id);
            }
            if (this.context.selectedAttributes[1]) {
                newRecentRecordAttributes.push(this.context.selectedAttributes[1]._id);
            }
            await updateItem(this.props.portalId, currentEntity.menuItemId, {
                attributes: newRecentRecordAttributes
            }, currentEntity.recentRecordId);
            currentEntity.recentRecordAttributes = this.context.selectedAttributes;
            this.context.setEntities(entities);
        } catch (e) {
            console.error(e);
        } finally {
            this.saveAttributeButton.current.disabled = false;
            this.attributeFormSubmitted = false;
            this.closeEditAttributeDialog();
        }
    };

    dragStart(dataItem) {
        debugger;
        let dataItemIndex = this.context.entities.findIndex(
            (entity) => entity.menuItemId === dataItem.menuItemId
        );
        this.context.startDrag(dataItem, dataItemIndex);
    }

    reorder(dataItem) {
        if (this.context.draggedItem.menuItemId === dataItem.menuItemId) {
            if (
                this.context.draggedOverItemIndex !==
                this.context.draggedItemIndex
            ) {
                // this.context.handleDraggedOverItem({}, -1);
                // this.setState({ draggedOverItemIndex: -1 });
            }
            return;
        }

        const draggedOverItemIndex = this.context.entities.findIndex(
            (p) => p.menuItemId === dataItem.menuItemId
        );

        this.context.handleDraggedOverItem(dataItem, draggedOverItemIndex);
    }

    endDrag(dataItem) {
        let { draggedItemIndex, draggedOverItemIndex } = this.context;

        if (draggedOverItemIndex === -1) {
            return;
        }

        let reorderedData = this.context.entities.slice();
        let temp = reorderedData[draggedItemIndex];
        let index = draggedOverItemIndex;

        reorderedData.splice(draggedItemIndex, 1);
        reorderedData.splice(draggedOverItemIndex, 0, temp);

        let newOrder;

        if (reorderedData.length > 2) {
            if (index === reorderedData.length - 1) {
                newOrder =
                    parseInt(reorderedData[index - 1]["order"]) + 10000000000;
                reorderedData[index]["order"] = newOrder;
            } else if (index === 0) {
                newOrder = parseInt(reorderedData[1]["order"]);
                let prevElementOrder = parseInt(reorderedData[2]["order"]);
                let orderToSet = (prevElementOrder + newOrder) / 2;
                reorderedData[index]["order"] = newOrder;
                reorderedData[1]["order"] = orderToSet;
                reorderedData[1].isChanged = true;
            } else {
                let prevItemOrder = parseInt(reorderedData[index - 1]["order"]);
                let nextItemOrder = parseInt(reorderedData[index + 1]["order"]);
                newOrder = (prevItemOrder + nextItemOrder) / 2;
                reorderedData[index]["order"] = newOrder;
            }
            reorderedData[index].isChanged = true;
        } else {
            let firstOrder = reorderedData[0]["order"];
            let secondOrder = reorderedData[1]["order"];

            reorderedData[0]["order"] = secondOrder;
            reorderedData[1]["order"] = firstOrder;

            reorderedData[0].isChanged = true;
            reorderedData[1].isChanged = true;
        }

        reorderedData = reorderedData.map((entity, index) => ({
            ...entity,
            currentIndex: index,
        }));

        this.context.handleDragEnd(reorderedData);
    }
}

class DragCell extends React.Component {
    render() {
        return (
            <td
                style={{ textAlign: "center" }}
                onDragOver={(e) => {
                    DragCell.reorder(this.props.dataItem);
                    e.preventDefault();
                    e.dataTransfer.dropEffect = "copy";
                }}
                onDragEnd={(e) => {
                    e.preventDefault();
                    DragCell.endDrag(this.props.dataItem);
                }}
            >
                <span
                    draggable="true"
                    style={{ cursor: "move" }}
                    onDragStart={(e) => {
                        DragCell.dragStart(this.props.dataItem);
                        e.dataTransfer.setData("dragging", "");
                    }}
                >
                    <i
                        className="fas fa-grip-vertical" />
                </span>
            </td>
        );
    }
}

class ShowCell extends React.Component {

    static contextType = SimpleConfigContext;

    render() {
        return (
            <td>
                <Checkbox checked={this.props.dataItem.show}
                    onChange={this.handleChange} className="ps-2">
                </Checkbox>
            </td>
        );
    }

    handleChange = (e) => {
        const { index } = this.props.dataItem;
        const { value } = e;
        this.context.updateEntityShowAtIndex(index, value);
    };
}

class LabelCell extends React.Component {

    static contextType = SimpleConfigContext;

    render() {
        return (
            <td>
                <input
                    title={this.props.dataItem.label}
                    className="form-control w-99"
                    value={this.props.dataItem.label}
                    onChange={this.handleChange}
                    maxLength={128} />
            </td>
        );
    }

    handleChange = (e) => {
        const { index } = this.props.dataItem;
        const { value } = e.target;
        this.context.updateEntityLabelAtIndex(index, value);
    }
}

class LabelTranslationCell extends React.Component {
    static contextType = SimpleConfigContext;
    render() {
        return (
            <td>
                <buttton
                    onClick={() => {
                        this.context.toggleEditLabelTranslationDialog()
                        this.context.setSelectedEntity(this.props.dataItem)
                    }}
                    className="btn btn-secondary">
                    <i className="fas fa-language"></i>
                </buttton>
            </td>
        );
    }
}

class AttributeEditCell extends React.Component {
    static contextType = SimpleConfigContext;

    render() {
        const { recentRecordId } = this.props.dataItem;

        if (recentRecordId === null) {
            return <td></td>;
        }

        return (
            <td>
                <OverlayTrigger
                    placement="top"
                    overlay={(props) => (
                        <Tooltip {...props}>
                            {this.props.t("grid.tooltip.select_properties")}
                        </Tooltip>
                    )}
                >
                    <button
                        onClick={this.showEditAttributeDialog}
                        className="btn btn-secondary"
                    >
                        <i className="fas fa-pencil" />
                    </button>
                </OverlayTrigger>
            </td>
        );
    }

    showEditAttributeDialog = () => {
        getAttributes(this.props.dataItem.allItemProperties.entityId)
            .then(this.orderAttributes)
            .then(this.context.setEntityAttributes);
        this.context.toggleEditAttributeDialog({
            selectedRecentRecordId: this.props.dataItem.recentRecordId,
            selectedAttributes: this.props.dataItem.recentRecordAttributes,
            defaultRecentRecordAttributes:
                this.props.dataItem.defaultRecentRecordAttributes,
            entityAttributesLoading: true,
        });
    };

    orderAttributes = (attributes) => {
        const systemAttributes = attributes.filter(attr => attr.isSystemAttribute);
        const orderedAttributes = attributes.filter(attr => !attr.isSystemAttribute).sort((a, b) => a.order - b.order);
        orderedAttributes.push(...systemAttributes);
        return orderedAttributes;
    }
}

export default withTranslation("portal_simple_config/menu_items")(MenuItems);